import React from 'react';
import { Bot, Maximize2, Minimize2, Trash2, X } from 'lucide-react';

/**
 * Header bar for <BaselinxCopilot>: logo + title + clear/expand/close.
 */
const CopilotHeader = ({ isExpanded, onClear, onToggleExpand, onClose }) => (
  <div className="flex items-center justify-between p-4 border-b border-slate-700 bg-gradient-to-r from-slate-800 to-slate-900 rounded-t-2xl">
    <div className="flex items-center gap-3">
      <div className="p-2 bg-gradient-to-br from-cyan-500 to-purple-600 rounded-lg">
        <Bot className="w-5 h-5 text-white" />
      </div>
      <div>
        <h3 className="text-white font-bold">Baselinx Copilot</h3>
        <p className="text-gray-500 text-xs">AI-powered PLM assistant</p>
      </div>
    </div>
    <div className="flex items-center gap-2">
      <button
        data-testid="copilot-clear-btn"
        onClick={onClear}
        className="p-2 text-gray-400 hover:text-red-400 transition rounded-lg hover:bg-slate-800"
        title="Clear history"
      >
        <Trash2 className="w-4 h-4" />
      </button>
      <button
        data-testid="copilot-expand-btn"
        onClick={onToggleExpand}
        className="p-2 text-gray-400 hover:text-white transition rounded-lg hover:bg-slate-800"
      >
        {isExpanded ? <Minimize2 className="w-4 h-4" /> : <Maximize2 className="w-4 h-4" />}
      </button>
      <button
        data-testid="copilot-close-btn"
        onClick={onClose}
        className="p-2 text-gray-400 hover:text-white transition rounded-lg hover:bg-slate-800"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  </div>
);

export default CopilotHeader;
